"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function appendStylesheet(href) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
}
exports.appendStylesheet = appendStylesheet;
function appendScript(src) {
    return new Promise(function (res, rej) {
        var script = document.createElement('script');
        script.src = src;
        script.onload = function () { return res(); };
        script.onerror = function () { return rej(); };
        document.body.appendChild(script);
    });
}
exports.appendScript = appendScript;
//# sourceMappingURL=dom.js.map